import { DropdownOptions } from '@components/common/formControl/dropdown';
import { IRadioButtonChipOptions } from '@components/common/formControl/radioButtonChip';

export interface IDetailedAddressType {
	longitude: string;
	latitude: string;
	pincode: string;
	city: string;
}

export interface ISiteInfoType {
	siteName: string;
	siteLocation: string;
	siteAddress: string;
	longitude: string;
	latitude: string;
	pincode: string;
	city: string;
	siteType: string;
	typeOfProperty: string;
	propertyArea: string;
	siteStage: string;
	is_bathroom: boolean;
	is_other_rooms: boolean;
	bathroom_work_status: string;
	other_rooms_work_status: string;
}

export const siteInfoInitialValues: ISiteInfoType = {
	siteName: '',
	siteLocation: '',
	siteAddress: '',
	longitude: '',
	latitude: '',
	pincode: '',
	city: '',
	siteType: '',
	typeOfProperty: '',
	propertyArea: '',
	siteStage: '',
	is_bathroom: false,
	is_other_rooms: false,
	bathroom_work_status: '',
	other_rooms_work_status: '',
};

export const SiteTypeLabel = {
	Residential: 'Residential',
	Commercial: 'Commercial',
};

export const SiteStageLabel = {
	Upcoming: 'Upcoming',
	Active: 'Active',
};

export const siteTypeList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Residential', value: SiteTypeLabel.Residential, icon: 'icon-home3' },
	{ id: 2, label: 'Commercial', value: SiteTypeLabel.Commercial, icon: 'icon-buildings' },
];

export const siteStageList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Woodworking yet to Start', value: SiteStageLabel.Upcoming },
	{ id: 2, label: 'Woodworking Started', value: SiteStageLabel.Active },
];

export const residentialTypeOfPropertyList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Independent Home/Bunglow', value: 'home-bunglow', icon: 'icon-home3' },
	{ id: 2, label: 'Apartment', value: 'apartment', icon: 'icon-buildings' },
];

export const commercialTypeOfPropertyList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Showroom/Supermarket', value: 'Showroom/Supermarket', icon: 'icon-cart' },
	{ id: 2, label: 'Office Space', value: 'Office Space', icon: 'icon-desk' },
	{ id: 5, label: 'School/College/University', value: 'School/College/University', icon: 'icon-education-cap' },
	{ id: 6, label: 'Factory Setup', value: 'Factory Setup', icon: 'icon-factory1' },
	{ id: 3, label: 'Restaurant/Hotel', value: 'Restaurant/Hotel', icon: 'icon-hotel-order' },
	{ id: 4, label: 'Hospital/Clinic', value: 'Hospital/Clinic', icon: 'icon-hospital' },
	{ id: 7, label: 'PG/Dormitories', value: 'PG/Dormitories', icon: 'icon-buildings' },
];

export const propertyAreaList: DropdownOptions[] = [
	{ id: 1, value: '0-300' },
	{ id: 2, value: '301-800' },
	{ id: 3, value: '801-1,500' },
	{ id: 4, value: '1,501-3000' },
	{ id: 5, value: '3,001-5000' },
	{ id: 6, value: '>5000' },
];

export const TilingWorkStatusList: DropdownOptions[] = [
	{ id: 1, value: 'Already Done' },
	{ id: 2, value: 'Ongoing' },
	{ id: 3, value: 'Not Started Yet' },
];

export const TilingWorkList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Bathroom', value: 'Bathroom' },
	{ id: 2, label: 'Other Rooms', value: 'Other Rooms' },
];
